<template>
  <div
    v-if="isVisible"
    class="parcel-forum-banner"
  >
    <div class="parcel-forum-content">
      <div class="parcel-forum-brand-section">
        <div>
          <img
            class="reelables-logo"
            :src="logo"
            :height="40"
            alt="Reelables logo"
          >
          <div class="parcel-forum-text">
            <p>
              <strong>Find us at</strong>
            </p>
            <p
              v-if="boothNumber"
              class="booth-text"
            >
              {{ boothNumber }}
            </p>
          </div>
        </div>
        <img
          src="https://www.parcelforum.com/event_guestside_app/_next/image?url=https%3A%2F%2Fimages.cvent.com%2F571c3bc17ff149ae81a3baae4443efaa%2Fpix%2Fa6fa7747a2f24464b1937be361c462a8!_!ff2c2be937216341f13d6fe2d0306407.png&w=3840&q=75"
          alt="Parcel Forum '26 Logo"
          class="parcel-forum-logo"
        >
      </div>

      <div class="parcel-forum-actions">
        <p class="find-us-text">
          <strong>Find us at</strong>
        </p>
        <span
          v-if="boothNumber"
          class="booth-badge"
        >{{ boothNumber }}</span>
        <button
          v-if="hasButton"
          class="banner-button"
          @click="clickButton"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LogoImage from '../../../assets/images/reelables-r-logo-white.svg';

export default {
  name: 'ParcelForum2026Banner',
  props: {
    boothNumber: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    logo() {
      return LogoImage;
    },
    hasButton() {
      return !!this.buttonText;
    },
  },
  methods: {
    clickButton() {
      this.$emit('button-click');
    },
  },
};
</script>

<style scoped lang="scss">
.parcel-forum-banner {
  position: absolute;
  top: 0;
  background: linear-gradient(90deg, #016389 0%, #d5ffff 55%);
  color: #000;
  padding: 8px;
  border-bottom: 3px solid #F04E4D;
  font-family: Arial, sans-serif;
  width: 100%;
  z-index: 10;
}

.parcel-forum-content {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.parcel-forum-brand-section {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  > div {
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 20px;
  }
}

.parcel-forum-logo {
  height: 45px; /* Adjust height as needed */
  width: auto;
}

.reelables-logo {
  margin-left: -8px;
}

.parcel-forum-text p {
  margin: 0;
  font-size: 14px;
  color: #000;
}

.details {
  display: block;
  font-size: 12px;
}

.parcel-forum-actions {
  display: flex;
  align-items: center;
  margin-left: 20px;
  gap: 15px;
}

.parcel-forum-text{
  display: none;
}

.booth-badge {
  background-color: lighten(#F04E4D, 10%);
  color: #000;
  padding: 3px 8px;
  font-weight: bold;
  font-size: 14px;
  border-radius: 2px;
}

.banner-button {
  background-color: #ffffff;
  color: #002e5d;
  padding: 6px 14px;
  text-decoration: none;
  font-weight: bold;
  font-size: 13px;
  border-radius: 4px;
  transition: 0.2s ease-in-out;
}

.banner-button:hover {
  background-color: #d4af37;
  color: #ffffff;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .parcel-forum-logo {
    height: 40px;
  }
  .details {
    display: inline;
    margin-left: 5px;
  }
  .parcel-forum-actions {
    margin-left: 0;
  }
  .parcel-forum-text p {
    color: #fff;
    font-size: 12px;
  }
  .parcel-forum-text {
    display: block;
  }
  .booth-badge, .find-us-text {
    display: none; /* Hide booth on small mobile to save space */
  }
}
</style>
